
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaitaxifare() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Taxi Fare',
        heading: 'Prince Cabs: Pune to Mumbai Taxi Fare',
        headingDescription: 'Prince Cabs offers transparent and affordable Pune to Mumbai Taxi Fare, ensuring safe, comfortable, and budget-friendly travel. Our fleet includes well-maintained sedans, SUVs, and luxury cars, providing options to suit every travel need—whether it’s airport transfers, business trips, or family journeys. With professional chauffeurs, on-time pickups, and fixed pricing, we guarantee a smooth travel experience on the Pune–Mumbai Expressway. Choose Prince Cabs’ reliable taxi service from Pune to Mumbai for comfort, safety, and value at the best fares.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is the most iconic symbol of Mumbai overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Tourists gather here to enjoy sea views and ferry rides to Elephanta Caves. The monument is especially enchanting at sunset and when illuminated at night. It is a starting point for exploring South Mumbai. The Gateway remains Mumbai’s proudest landmark."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, stretching 3.6 km along the Arabian Sea, is popularly known as the Queen’s Necklace. The promenade is perfect for evening walks, jogging, and enjoying sea breezes. At night, streetlights resemble a sparkling necklace, creating a magical view. Locals and tourists flock here for sunsets and monsoon waves. It represents the vibrant and modern spirit of Mumbai. Marine Drive is the city’s favorite leisure hub."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in 1887, it showcases Gothic Revival architecture with stained glass windows, domes, and spires. At night, the building is beautifully illuminated. It is both a transport hub and a cultural attraction. Visitors admire its architectural grandeur while experiencing Mumbai’s lifeline—the local trains. CST is a historic jewel of the city."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating back to the 5th–6th centuries. The highlight is the massive Trimurti sculpture of Lord Shiva. The caves display exquisite artistry blending Hindu and Buddhist traditions. Accessible via ferry from the Gateway of India, it is a peaceful retreat from the city. The caves reflect India’s ancient cultural and spiritual legacy. It is a must-visit for history enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, known for its lively vibe and street food stalls. Pav bhaji, bhel puri, and ice gola are crowd favorites here. Bollywood celebrities often reside nearby, making it a hotspot for star spotting. Families and tourists love the evening atmosphere and sea breezes. Sunsets at Juhu are simply breathtaking. It is the perfect place to experience Mumbai’s coastal lifestyle."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it attracts thousands of devotees daily, including Bollywood stars and politicians. The golden dome and intricately carved doors add grandeur to the temple. Tuesdays are especially busy with massive crowds seeking blessings. Devotees believe wishes made here are always fulfilled. It is the spiritual heart of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge connecting South Mumbai with its suburbs. It is an engineering marvel offering stunning views of the Arabian Sea. Driving across the bridge is a thrilling experience, especially at night when illuminated. It has reduced travel time between Bandra and Worli significantly. The Sea Link is a modern icon of Mumbai’s skyline. It represents the city’s progress and ambition."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a famous shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it blends Indo-Islamic architecture. The dargah is connected to the mainland by a narrow causeway accessible during low tide. Devotees of all faiths visit for blessings. Its setting amidst the sea creates a divine atmosphere. Haji Ali is both spiritual and scenic."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s busiest street market, popular for budget shopping and food. Tourists shop for clothes, handicrafts, jewelry, and antiques at bargain prices. The area is also home to iconic cafés like Leopold Café and Café Mondegar. Street vendors and shops create a lively vibe. It is always bustling with locals and tourists alike. Colaba reflects Mumbai’s cosmopolitan culture."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a famous beach in South Mumbai, best known for Ganesh Visarjan celebrations. The beach is popular for evening snacks like pav bhaji, kulfi, and bhel. Families gather here to enjoy cool breezes and sea views. Festivals and cultural events make it vibrant year-round. The beach also offers views of Marine Drive’s arc. Girgaon Chowpatty is Mumbai’s traditional seaside hangout."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood movie-making, spread over 500 acres. It features multiple studios, artificial sets, and shooting locations. Visitors can take guided tours to explore behind-the-scenes of films. Cinema enthusiasts love spotting live shoots here. It is one of the largest film production centers in the world. Film City showcases Mumbai’s identity as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a 87 sq. km green sanctuary within Mumbai. It is home to leopards, deer, and over 200 bird species. Inside the park, the ancient Kanheri Caves display Buddhist stupas and rock-cut monasteries. Visitors enjoy safaris, treks, and toy train rides. The park is a rare natural retreat within a metro city. It blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and modern high-rises. It is a favorite for birdwatchers, with species like kingfishers and herons. The promenade attracts joggers and evening walkers. During monsoon, the lake looks especially scenic with mist and greenery. Photographers capture stunning reflections of the skyline here. Powai Lake offers peace in the middle of Mumbai’s hustle."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, located near Gorai, is one of the world’s largest meditation domes. Built in Burmese style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation programs and admire its stunning design. The seaside location enhances its tranquility. It is a spiritual landmark promoting peace and mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub inspiring curiosity about space and astronomy. It offers immersive sky shows explaining planets, galaxies, and stars. The adjoining Science Centre has interactive exhibits on technology. Families and students love the engaging displays. Special events are held during eclipses and celestial phenomena. It is Mumbai’s destination for science and learning."
  }
],

"services": [
  {
    "name": "Pune to Mumbai Cab Charges",
    "description": "Detailed cab charges for travel from Pune to Mumbai, ensuring transparency and fair pricing."
  },
  {
    "name": "Pune to Mumbai Taxi Cost",
    "description": "Comprehensive taxi cost information for Pune to Mumbai routes, helping you plan your budget."
  },
  {
    "name": "Pune to Mumbai Innova Taxi Fare",
    "description": "Competitive Innova taxi fares for Pune to Mumbai journeys, combining comfort and value."
  },
  {
    "name": "Pune to Mumbai Crysta Fare",
    "description": "Transparent pricing for Crysta cabs on the Pune to Mumbai route for premium travel."
  },
  {
    "name": "Pune to Mumbai Sedan Fare",
    "description": "Affordable sedan taxi fares from Pune to Mumbai, suitable for economical travel."
  },
  {
    "name": "Pune to Mumbai Dzire Fare",
    "description": "Budget-friendly Dzire taxi fares for comfortable rides from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai Etios Fare",
    "description": "Economical Etios taxi fare details for Pune to Mumbai trips, ideal for small groups."
  },
  {
    "name": "Pune to Mumbai Affordable Taxi Fare",
    "description": "Cost-effective taxi fares for Pune to Mumbai routes without compromising on service quality."
  },
  {
    "name": "Pune to Mumbai Tour Fare",
    "description": "Tour package fares for Pune to Mumbai trips, including sightseeing and travel convenience."
  },
  {
    "name": "Pune to Mumbai One Way Fare",
    "description": "Transparent one way fare details for taxi services from Pune to Mumbai."
  },
  {
    "name": "Pune to Mumbai Drop Taxi Cost",
    "description": "Clear and reasonable drop taxi costs for Pune to Mumbai travel."
  },
  {
    "name": "Pune to Mumbai Cab Per Km Rate",
    "description": "Per kilometer cab rates for Pune to Mumbai trips, helping you estimate travel expenses."
  },
  {
    "name": "Pune to Mumbai Fare Calculator",
    "description": "Interactive fare calculator to estimate taxi costs for Pune to Mumbai journeys."
  },
  {
    "name": "Pune to Mumbai Round Trip Fare",
    "description": "Competitive round trip taxi fares for travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Ertiga Taxi Charges",
    "description": "Transparent Ertiga taxi charges for comfortable and affordable Pune to Mumbai rides."
  }
],
"tableData": [
  ["Pune to Mumbai Cab Charges", "Pune to Mumbai Taxi Cost"],
  ["Pune to Mumbai Innova Taxi Fare", "Pune to Mumbai Crysta Fare"],
  ["Pune to Mumbai Sedan Fare", "Pune to Mumbai Dzire Fare"],
  ["Pune to Mumbai Etios Fare", "Pune to Mumbai Affordable Taxi Fare"],
  ["Pune to Mumbai Tour Fare", "Pune to Mumbai One Way Fare"],
  ["Pune to Mumbai Drop Taxi Cost", "Pune to Mumbai Cab Per Km Rate"],
  ["Pune to Mumbai Fare Calculator", "Pune to Mumbai Round Trip Fare"],
  ["Pune to Mumbai Ertiga Taxi Charges"]
],


"whychoose": [
  {
    "WhyChooseheading": "Affordable Pune to Mumbai Taxi Fare",
    "WhyChoosedescription": "Prince Cabs offers competitive and transparent taxi fares from Pune to Mumbai, ensuring you get the best value without any hidden charges."
  },
  {
    "WhyChooseheading": "Clear and Inclusive Pricing Structure",
    "WhyChoosedescription": "Our fare includes fuel, tolls, driver allowance, and taxes, providing a hassle-free and upfront cost for your Pune to Mumbai journey."
  },
  {
    "WhyChooseheading": "Flexible Fare Options to Fit Your Budget",
    "WhyChoosedescription": "Choose from one-way trips, round trips, or hourly rentals with pricing packages tailored to meet your specific travel needs."
  },
  {
    "WhyChooseheading": "Multiple Secure Payment Methods",
    "WhyChoosedescription": "We accept various payment options including UPI, credit/debit cards, net banking, and cash to provide convenient and secure transactions."
  },
  {
    "WhyChooseheading": "No Hidden Charges or Extra Fees",
    "WhyChoosedescription": "Our pricing is fully transparent, with no surprise fees, ensuring peace of mind and trustworthiness in your taxi fare."
  },
  {
    "WhyChooseheading": "Cost-Effective for Group Travel",
    "WhyChoosedescription": "Booking with Prince Cabs is economical for families and groups, helping you save more compared to multiple single-seat rides."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Fare-Related Queries",
    "WhyChoosedescription": "Our customer care team is available around the clock to assist you with any fare questions, booking support, or travel assistance."
  }
]






















    }

const faqData = [
    {
        question: 'What is the taxi fare from Pune to Mumbai?',
        answer: 'Taxi fares from Pune to Mumbai vary based on the vehicle type, trip duration, and any additional services requested.',
    },
    {
        question: 'Which vehicle options affect the Pune to Mumbai taxi fare?',
        answer: 'Vehicle options include Swift Dzire, Innova, and Tempo Traveller, each with different fare structures to suit your needs.',
    },
    {
        question: 'Are there any additional charges on top of the base Pune to Mumbai taxi fare?',
        answer: 'Additional charges may apply for tolls, night travel, or extra waiting time, depending on your trip specifics.',
    },
    {
        question: 'How can I get an exact fare quote for Pune to Mumbai taxi service?',
        answer: 'You can contact Prince Cabs directly via phone or our website for a personalized and accurate fare estimate.',
    },
    {
        question: 'Does Prince Cabs offer fixed or meter-based fares for Pune to Mumbai?',
        answer: 'Prince Cabs offers fixed fare packages for Pune to Mumbai trips to provide clarity and transparency to customers.',
    },
    {
        question: 'Is the Pune to Mumbai taxi fare negotiable?',
        answer: 'Fares are competitive and based on fixed rates; however, special packages and discounts may be available on request.',
    },
    {
        question: 'How do I pay for my Pune to Mumbai taxi fare?',
        answer: 'Payments can be made via cash, credit/debit card, or online payment methods as per your convenience.',
    },
];

const testimonials = [
    {
        name: "Mr. Anil Patil",
        position: "Regular Commuter",
        text: "Prince Cabs offers transparent and reasonable fares from Pune to Mumbai. No hidden charges, and great service.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-fare-1.png",
    },
    {
        name: "Ms. Kavita Desai",
        position: "Leisure Traveler",
        text: "I appreciated the clear fare information and professionalism of Prince Cabs on my Pune to Mumbai taxi ride.",
        image: "/img/testimonial/testimonial-thumb-pune-mumbai-fare-2.png",
    },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai Taxi Fare",
  "description": "Transparent and competitive taxi fares for travel from Pune to Mumbai. Get fare estimates for Innova, Crysta, Sedan, Dzire, Etios, Ertiga and more. One way and round trip options available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mumbai Cab Charges",
    "Pune to Mumbai Taxi Cost",
    "Pune to Mumbai Innova Taxi Fare",
    "Pune to Mumbai Crysta Fare",
    "Pune to Mumbai Sedan Fare",
    "Pune to Mumbai Dzire Fare",
    "Pune to Mumbai Etios Fare",
    "Pune to Mumbai Affordable Taxi Fare",
    "Pune to Mumbai Tour Fare",
    "Pune to Mumbai One Way Fare",
    "Pune to Mumbai Drop Taxi Cost",
    "Pune to Mumbai Cab Per Km Rate",
    "Pune to Mumbai Fare Calculator",
    "Pune to Mumbai Round Trip Fare",
    "Pune to Mumbai Ertiga Taxi Charges"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Taxi Fare | Per KM Charges, One Way & Round Trip Cost</title>
  <meta
    name="description"
    content="Check Pune to Mumbai taxi fare for Innova, Crysta, Dzire, Etios, Ertiga and Sedan cabs. Get the latest one way, drop and round trip taxi charges and fare calculator."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Cab Charges, Pune to Mumbai Taxi Cost, Pune to Mumbai Innova Taxi Fare, Pune to Mumbai Crysta Fare, Pune to Mumbai Sedan Fare, Pune to Mumbai Dzire Fare, Pune to Mumbai Etios Fare, Pune to Mumbai Affordable Taxi Fare, Pune to Mumbai Tour Fare, Pune to Mumbai One Way Fare, Pune to Mumbai Drop Taxi Cost, Pune to Mumbai Cab Per Km Rate, Pune to Mumbai Fare Calculator, Pune to Mumbai Round Trip Fare, Pune to Mumbai Ertiga Taxi Charges"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaitaxifare ;